import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import moment from 'moment';

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { Input, RenderInputFields, SubmitButton, SelectInput, Textarea } from "../Form/Form";
import { DefaultCountryCode, NAME_LIMIT } from "../../util/other";

const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    setValue,
    control
  } = useForm();

  const { response, request } = useRequest();
  const { request: requestSport, response: responseSport } = useRequest();
  const { request: requestCountry, response: responseCountry } = useRequest();
  const { request: requestCCodes, response: responseCCodes } = useRequest();
  const [image, setImage] = useState();
  const [displayImage, setDisplayImage] = useState();
  const [allSports, setAllSports] = useState([]);
  const [allCountry, setAllCountry] = useState([]);
  const [allCountryCodes, setAllCountryCodes] = useState([]);
  const history = useHistory();

  const minDateOfBirth = moment().subtract(1, 'days').format("YYYY-MM-DD") + ' 23:59:59';

  useEffect(() => {
    document.title = "Add Club - Calevalab";
    requestSport("GET", `master/all?page=1&isActive=${true}`)
    requestCountry("GET", `country/all?page=1&isActive=${true}`)
    requestCCodes("GET", `country-codes/all`)
  }, []);

  useEffect(() => {
    if (responseSport && responseSport.status) {
      setAllSports(responseSport.sports)
    }
  }, [responseSport])

  useEffect(() => {
    if (responseCountry && responseCountry.status) {
      setAllCountry(responseCountry.data)
    }
  }, [responseCountry])

  useEffect(() => {
    if (responseCCodes && responseCCodes.status) {
      if (responseCCodes.data && responseCCodes.data.length > 0) {
        const selectedCodeObj = responseCCodes.data.find(obj => {
          if (obj.dial_code == DefaultCountryCode.CountryCode) {
            return obj;
          }
        })
        setValue('countryCode', selectedCodeObj?._id)
      }
      setAllCountryCodes(responseCCodes.data)
    }
  }, [responseCCodes])


  useEffect(() => {
    if (response) {
      toast.success("Club has been added successfully.");
      history.push("/clubs");
    }
  }, [response]);

  const onSubmit = (data) => {
    const {
      firstName,
      lastName,
      gender,
      dob,
      country,
      organizationName,
      organizationShortName,
      organizationAddress,
      organizationCity,
      organizationCode,
      sport,
      organizationWebsite,
      email,
      password,
      confirmpassword,
      contact,
      countryCode,
      approvalStatus
    } = data;

    let error = 0;
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      )
    ) {
      setError("email", {
        type: "manual",
      });
      error = 1;
    }

    if (new Date(dob).getTime() > new Date(minDateOfBirth).getTime()) {
      setError("dob", { type: "manualDOB" })
      error = 1;
    }


    if (password !== confirmpassword) {
      setError("confirmpassword", {
        type: "manual",
      });
      error = 1;
    }

    let fd = new FormData();

    if (data.image && data.image.length > 0) {
      if (data.image[0].type) {
        const typeArr = data.image[0].type.split("/");
        if (typeArr.length > 0 && typeArr[0] && typeArr[0] != 'image') {
          setError("image", {
            type: "manual",
          });
          error = 1;
        } else {
          fd.append("file", data.image[0]);
        }
      }
    }

    if (error == 1) {
      return;
    }
    fd.append("firstName", firstName);
    fd.append("lastName", lastName);
    fd.append("organizationCode", organizationCode);
    fd.append("password", password);
    fd.append("email", email);
    fd.append("gender", gender);
    fd.append("dob", dob);
    fd.append("country", country);
    fd.append("organizationName", organizationName);
    fd.append("organizationShortName", organizationShortName);
    fd.append("organizationAddress", organizationAddress);
    fd.append("organizationCity", organizationCity);
    fd.append("sportName", sport);
    fd.append("organizationWebsite", organizationWebsite);
    fd.append("contact", contact);
    fd.append("countryCode", countryCode);
    fd.append("approvalStatus", approvalStatus)

    request("POST", "club", fd);
  };


  const handleImage = (event) => {
    event.preventDefault();
    if (event.target.files[0]) {
      const typeArr = event.target.files[0].type.split("/");
      if (typeArr.length > 0 && typeArr[0] && typeArr[0] != 'image') {
        setError("image", { type: "manual" });
        setValue("image", event.target.files[0]);
        setDisplayImage("")
        return;
      }
      setDisplayImage(URL.createObjectURL(event.target.files[0]));
      clearErrors('image')
    } else {
      setDisplayImage("");
      setImage("");
      setValue("image", "");
    }
  };
  const handleRemoveImage = () => {
    if (displayImage) {
      setDisplayImage(null);
      setValue("image", null);
    } else {
      setImage(null);
    }
  };

  const handleDate = (e, name) => {

    if (name == 'dob') {
      setValue('dob', e.target.value)
      clearErrors('dob')
    }
  }


  const InputFields = [
    [
      {
        Component: Input,
        label: "First Name",
        type: "text",
        name: "firstName",
        registerFields: {
          required: true,
          pattern: /^[\S.]+(?:[\s.]+[\S.]+)*$/,
          maxLength: NAME_LIMIT,
          isNameField: true
        },
        registerFieldsFeedback: {
          pattern: "Please enter valid first name.",
        },
      },
      {
        Component: Input,
        label: "Last Name",
        type: "text",
        name: "lastName",
        registerFields: {
          required: true,
          pattern: /^[\S.]+(?:[\s.]+[\S.]+)*$/,
          maxLength: NAME_LIMIT,
          isNameField: true

        },
        registerFieldsFeedback: {
          pattern: "Please enter valid last name.",
        },
      },
      {
        Component: SelectInput,
        label: "Gender",
        name: "gender",
        registerFields: {
          required: false,
          isNoOnChange: true
        },
        children: (
          [
            { value: "", label: "Select Gender" },
            { value: "male", label: "Male" },
            { value: "female", label: "Female" },
          ]
        ),
        control: control
      },
      {
        Component: Input,
        label: "Date Of Birth",
        type: "date",
        name: "dob",
        registerFields: {
          required: false,
          isNoOnChange: false
        },
        otherRegisterFields: {
          manual: true,
          feedback: "Please select valid date of birth.",
        },
        isDate: true,
        max: moment().subtract(1, 'days').format("YYYY-MM-DD"),
        handleDateChange: handleDate,
        control: control
      },

      {
        Component: SelectInput,
        label: "Country",
        name: "country",
        registerFields: {
          required: true,
          isNoOnChange: true
        },

        children: (
          [
            { value: "", label: "Select Country" },
            ...(allCountry && allCountry.length > 0
              ? allCountry.map(obj => ({ value: obj._id, label: obj.name }))
              : []
            )
          ]
        ),
        control: control
      }
    ], [
      {
        Component: Input,
        label: "Organization Name",
        type: "text",
        name: "organizationName",
        registerFields: {
          required: true,
        },
      },

      {
        Component: Input,
        label: "Organization Short Name",
        type: "text",
        name: "organizationShortName",
        registerFields: {
          required: true,
        },
      },
      {
        Component: Textarea,
        label: "Organization Address",
        name: "organizationAddress",
        colClass: "col-lg-12",
        registerFields: {
          required: true,
        },
      },
      {
        Component: Input,
        label: "Organization City",
        type: "text",
        name: "organizationCity",
        registerFields: {
          required: true,
        },
      },

      {
        Component: Input,
        label: "Code",
        type: "text",
        name: "organizationCode",
        registerFields: {
          required: true,
        },
      },
      {
        Component: SelectInput,
        label: "Sport",
        name: "sport",
        registerFields: {
          required: true,
          isNoOnChange: true
        },
        children: (
          [
            { value: "", label: "Select Sport" },
            ...(allSports && allSports.length > 0
              ? allSports.map(obj => ({ value: obj._id, label: obj.name }))
              : []
            )
          ]
        ),
        control: control
      },

      {
        Component: Input,
        label: "Organization Website",
        type: "text",
        name: "organizationWebsite",
        registerFields: {
          required: false,
        },
      },

      {
        Component: Input,
        label: "Logo",
        type: "file",
        name: "image",
        registerFields: {
          required: false,
        },
        handleMedia: handleImage,
        handleRemoveMedia: handleRemoveImage,
        isMedia: true,
        accept: "image/*",
        control,
        image,
        displayImage,
        media: "image",
        otherRegisterFields: {
          manual: true,
          feedback: "Please select valid image extension type.",
        },
      },
    ],

    [
      {
        Component: Input,
        label: "Password",
        type: "password",
        name: "password",
        registerFields: {
          required: true,
          pattern: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&]).{10,}/,
        },
        registerFieldsFeedback: {
          pattern: "Password must be of 10 characters long with atleast one Uppercase, one Lowercase, one Number and one Special Character.",
        },
      },
      {
        Component: Input,
        label: "Confirm Password",
        type: "password",
        name: "confirmpassword",
        registerFields: {
          required: true,
          pattern: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&]).{10,}/,
        },
        registerFieldsFeedback: {
          pattern: "Confirm password must be of 10 characters long with atleast one Uppercase, one Lowercase, one Number and one Special Character.",
        },
        otherRegisterFields: {
          manual: true,
          feedback: "Both Passwords do not match.",
        },
      },
      {
        Component: Input,
        label: "Email",
        type: "email",
        name: "email",
        registerFields: {
          required: true,
          pattern:
            /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        },
        registerFieldsFeedback: {
          pattern: "The email field must be a valid email address.",
        },
      },
      {
        Component: SelectInput,
        label: "Country Code",
        name: "countryCode",
        colClass: "col-xl-2",
        extraClass: "countryCode-input",
        registerFields: {
          required: false,
          isNoOnChange: true
        },
        children: (
          allCountryCodes && allCountryCodes.length > 0
            ? allCountryCodes.map(obj => ({
              value: obj._id,
              label: obj.dial_code,
              selected: obj.dial_code === DefaultCountryCode?.CountryCode
            }))
            : []
        ),
        control: control
      },
      {
        Component: Input,
        label: "Phone Number",
        type: "text",
        name: "contact",
        colClass: "col-xl-4",
        registerFields: {
          required: false,
          pattern: /^[0-9]{7,12}$/gm,
        },
        registerFieldsFeedback: {
          pattern: "Phone number must be minimum 7 and maximum 12 digit number.",
        },
      },
    ],
    [
       {
        Component: SelectInput,
        label: "Status",
        name: "approvalStatus",
        registerFields: {
          required: true,
          isNoOnChange: true
        },
        children: (
          [
            { value: "Approved", label: "Active" },
            { value: "On-Hold", label: "On-Hold" },
            { value: "Pilot", label: "Pilot" },
          ]
        ),
        control: control
      },
    ]
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Add Club"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/clubs", name: "Back To Clubs" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">
                    Add New Club
                  </h3>

                  <form onSubmit={handleSubmit(onSubmit)}>
                    <RenderInputFields
                      InputFields={InputFields}
                      errors={errors}
                      register={register}
                    />

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Submit"
                    />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
